//@flow
import React, { Suspense } from 'react';
import { Router } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { createBrowserHistory } from 'history';
import MomentUtils from '@date-io/moment';
import { Provider as StoreProvider, useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { themeWithRtl as theme } from './theme';
import { configureStore } from './store';
import routesMap from './routes';
import GoogleAnalytics from './components/GoogleAnalytics';
import ScrollReset from './components/ScrollReset';
import StylesProvider from './components/StylesProvider';
import { SnackbarProvider } from 'notistack';
import initFirebase from './utils/firebase';
import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './mock';
import './assets/scss/main.scss';
import { LinearProgress } from '@material-ui/core';
import { initAuth } from './actions';
import SimpleReactLightbox from 'simple-react-lightbox';

const history = createBrowserHistory();
const store = configureStore();

function App() {
  React.useEffect(() => {
    initFirebase().then(() => {
      store.dispatch(initAuth());
    });
  }, []);

  return (
    <React.StrictMode>
      <SimpleReactLightbox>
        <StoreProvider store={store}>
          <StylesProvider direction="rtl">
            <ThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <SnackbarProvider>
                  <Main />
                </SnackbarProvider>
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </StylesProvider>
        </StoreProvider>
      </SimpleReactLightbox>
    </React.StrictMode>
  );
}

const Main = () => {
  const session = useSelector((state) => state.session);
  if (session.status !== 'ready') {
    return <LinearProgress />;
  }

  const { role } = session.user;

  const routes = routesMap[role];
  return (
    <Router history={history}>
      <ScrollReset />
      <GoogleAnalytics />
      <Suspense fallback={<LinearProgress />}>{renderRoutes(routes)}</Suspense>
    </Router>
  );
};

export default App;
